import { DodQueueSort, DodQueueSummaryV2, DodSortOrder } from 'api/dod/dod.v2.types';
import { DodQueueTotals } from '../overviewTab/dodFormat';

export type QueueRowKey = {
  rcpId: string;
  nlk: number;
};

/** The application's table keys its rows by `id`; a queue is identified by its RCP plus its NLK. */
export type QueueTableRow = DodQueueSummaryV2 & { id: string };

export const queueRowId = (row: QueueRowKey): string => `${row.rcpId}:${row.nlk}`;

export type QueueAction = 'drain' | 'pause' | 'resume';

export type QueuesTabProps = {
  rows: QueueTableRow[];
  /** Totals over the rows on this page; the summary line says so and adds the fleet-wide `total`. */
  totals: DodQueueTotals;
  isLoading: boolean;
  isError: boolean;
  /** Queues the API matched across the fleet, which is what the pagination counts. */
  total: number;
  /** 1-based, like every `page` query parameter in this app. */
  page: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (pageSize: number) => void;
  sort: DodQueueSort;
  order: DodSortOrder;
  onSortChange: (sort: DodQueueSort, order: DodSortOrder) => void;
  search: string;
  onSearchChange: (search: string) => void;
  isBacklogOnly: boolean;
  onBacklogOnlyToggle: () => void;
  selected: QueueRowKey | null;
  onSelect: (row: QueueRowKey | null) => void;
};
